const STORAGE_KEY = 'lpv_cookie_consent';

export function getConsent() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch (error) {
    // localStorage puede fallar (privado, cuotas) -- sin analitica ese caso, no rompemos la web.
  }
}
